import React, { useState, useEffect, useContext, Fragment } from "react";
import CityTable from './cityTable';
import { getAPI, putpost, masterServiceBaseUrl } from 'services/http';
import { GetPagination } from "../../common/commonComponents/pagination/pagination";
import { PermissionContext, RolePermissions } from "appContext";
import { PermisionDenied } from "../../common/commonComponents";
import CustomLoader from "../../common/commonComponents/Loader/loader";
import { pages } from "../../common/constant";
import { failureToast, successToast } from '../../common/utils/methods/toasterFunctions/function';

const City = () => {
  const [classArray, setclassArray] = useState([])
  const [apiloader, setapiloader] = useState(false)
  const [district, setDistrict] = useState([])
  const [city, setCity] = useState([])
  const [countries, setCountries] = useState([])
  const [states, setStates] = useState([])
  const [isSaveVisible, setisSaveVisible] = useState(false);
  const [tableData, setTableData] = useState([])
  const [pagination, setpagination] = useState({
    currentPage: 1,
    nextPage: null,
    previousPage: null,
    totalPage: null
  });

  const permissions = useContext(PermissionContext);
  const userPermissions = RolePermissions(permissions, pages["City"]['id']);

  const pageSize = 10
  const fetchClasses = async (url) => {
    setapiloader(true)
    getAPI(url, (data) => {
      setCity(data['data']);
      setTableData(data['data']);
      let n = pagination
      if (data['data'].length > pageSize) {
        n['nextPage'] = n.currentPage + 1
      }
      if (n.currentPage > 1) {
        n.previousPage = n.currentPage - 1
      }
      n['totalPage'] = Math.floor(data['data'].length / pageSize)
      if (data['data'].length % pageSize != 0) {
        n['totalPage'] += 1
      }
      setpagination(n)
      setapiloader(false)
      setclassArray(data['data'].slice(pagination.currentPage * (pageSize) - pageSize, pagination.currentPage * pageSize) || [])
    }, (data) => { failureToast(data['message']) })
  }

  const previousPage = () => {
    if (pagination.currentPage != 1) {
      setclassArray(
        city.slice(
          (pagination.currentPage - 1) * pageSize - pageSize,
          (pagination.currentPage - 1) * pageSize
        )
      );
      // console.log(
      //   city.slice(
      //     (pagination.currentPage - 1) * pageSize - pageSize,
      //     (pagination.currentPage - 1) * pageSize
      //   )
      // );
      let n = pagination;
      n["currentPage"] = n["currentPage"] - 1;
      if (n["currentPage"] == 1) {
        n["previousPage"] = null;
      } else {
        n["previousPage"] = n.currentPage;
      }
      setpagination(n);
    }
  };

  const fetchDropdown = async (url, droptype) => {
    setapiloader(true)
    getAPI(url, (data) => {
      const dropList = data.data.map(data => {
        if (droptype === 'country') {
          const { id, countryDispValue, status } = data;
          return { id: id, text: countryDispValue };
        }
        if (droptype === 'state') {
          const { id, stateDispValue, status } = data;
          return { id: id, text: stateDispValue };
        }

        if (droptype === 'district') {
          const { id, districtDispValue, status } = data;
          return { id: id, text: districtDispValue };
        }
      }
      );

      droptype === 'country' ? setCountries(dropList) : droptype === 'state' ? setStates(dropList) : setDistrict(dropList)
    }, (data) => { failureToast(data['message']) })
  }

  useEffect(() => {
    fetchClasses(masterServiceBaseUrl + '/city/getAllCity')
    fetchDropdown(masterServiceBaseUrl + '/country/getAllActiveCountry', 'country')
    fetchDropdown(masterServiceBaseUrl + '/state/getAllActiveState', 'state')
    fetchDropdown(masterServiceBaseUrl + '/district/getAllActiveDistrict', 'district')
  }, [])


  const refreshList = () => {
    fetchClasses(masterServiceBaseUrl + '/city/getAllCity')
  }

  return (
    <>
      {apiloader ? <CustomLoader
        apiLoader={apiloader}
        loaderHeight={'200px'}
        loaderWidth={'100% '}
      /> :
        <Fragment>
          {userPermissions ? <>
            <CityTable
              userPermissions={userPermissions}
              fetchClasses={fetchClasses}
              setclassArray={setclassArray}
              classArray={classArray}
              countryList={countries}
              stateList={states}
              districtList={district}
              tableData={tableData}
              city={city}
              setCity={setCity}
              pagination={pagination}
              setpagination={setpagination}
              isSaveVisible={isSaveVisible}
              setisSaveVisible={setisSaveVisible}
              refreshList={refreshList}
              previousPage={previousPage}
            />
            {pagination.totalPage > 1 ?
              <GetPagination
                isSaveVisible={isSaveVisible}
                fetchClasses={fetchClasses}
                setclassArray={setclassArray}
                pagination={pagination}
                setpagination={setpagination}
                pageSize={pageSize}
                state={city}
              />
              : null}
          </>
            : <PermisionDenied />}
        </Fragment>
      }
    </>
  );
}
export default City;